import { c as _c } from "react/compiler-runtime";
import { NotificationSettings } from './notification-settings';

/**
 * Dedicated settings panel component for chat area.
 * Displays settings content inline within the main chat content area
 * instead of as a modal dialog overlay. Matches the styling of the original dialog.
 */
export function ChatSettingsPanel() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex size-full min-w-0 flex-col"><div className="flex flex-1 items-start justify-center p-6"><div className="bg-background border-border flex w-full max-w-md flex-col rounded-sm border px-6 py-2"><NotificationSettings /></div></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}